// extracted by mini-css-extract-plugin
export default {"backgroundContainer":"HomePage_backgroundContainer__qKEMN","imageWrapper":"HomePage_imageWrapper__QUgDJ","projectsWrapper":"HomePage_projectsWrapper__6wPty"};